<template>
  <div class="template-container">
    <el-card class="box-card">
      <h2 class="title">Cargue Masivo Ucaps</h2>

      <div class="template-section">
        <el-card class="subsection-card">
          <h3>Descargar Plantilla</h3>
          <el-button
            type="primary"
            icon="el-icon-download"
            :loading="downloadLoadingTemplate"
            @click="descargarPlantilla"
          >
            Descargar
          </el-button>
          <h3>Descargar Inventario UCAPS</h3>
          <el-button
            type="primary"
            icon="el-icon-download"
            :loading="downloadLoadingInventory"
            @click="descargarInventario"
          >
            Descargar
          </el-button>
        </el-card>

        <el-card class="subsection-card">
          <h3>Subir Plantilla Completada</h3>
          <el-upload
            class="upload-demo"
            drag
            action="#"
            :auto-upload="false"
            :on-change="handleFileChange"
            :file-list="fileList"
            accept=".xlsx,.xls"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              Arrastra aquí tu archivo o haz clic para subirlo
            </div>
          </el-upload>
          <el-button
            type="success"
            icon="el-icon-check"
            class="mt-4"
            :disabled="!selectedFile"
            @click="procesarArchivo"
          >
            Procesar Archivo
          </el-button>
        </el-card>
      </div>
    </el-card>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import {
    getTemplateUcap,
    uploadTemplateUcap,
    getInventory
  } from '@/api/ucap_caracteristicas.js'
  export default {
    name: 'PlantillaUploader',
    data() {
      return {
        downloadLoadingTemplate: false,
        downloadLoadingInventory: false,
        selectedFile: null,
        fileList: []
      }
    },
    methods: {
      descargarPlantilla() {
        this.downloadLoadingTemplate = true
        console.log('Descargando plantilla...')
        getTemplateUcap()
          .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'cargue_masivo_ucap.xlsx')
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            this.downloadLoadingTemplate = false
          })
          .catch(error => {
            console.error('Error al descargar la plantilla:', error)
          })
      },
      descargarInventario() {
        this.downloadLoadingInventory = true
        console.log('Descargando inventario de UCAPS...')
        getInventory(this.empresa.empr_id, null)
          .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', 'inventario_ucaps.xlsx')
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
            this.downloadLoadingInventory = false
          })
          .catch(error => {
            console.error('Error al descargar el inventario:', error)
          })
      },
      handleFileChange(file, fileList) {
        console.log('Archivo seleccionado:', file)
        this.selectedFile = file.raw // muy importante: `raw` es el objeto real del archivo
        this.fileList = fileList
      },
      procesarArchivo() {
        this.$message.success('Archivo subido correctamente')
        if (!this.selectedFile) return

        const formData = new FormData()
        formData.append('file', this.selectedFile)

        uploadTemplateUcap(this.empresa.empr_id, this.usuario.usua_id, formData)
          .then(res => {
            console.log('Respuesta del servidor:', res)
            if (res.status === 200) {
              this.$message.success('Plantilla procesada correctamente')
            } else {
              this.$message.error('Error al procesar la plantilla')
            }
          })
          .catch(error => {
            console.error('Error al procesar la plantilla:', error)
          })
      },
      handleError(error) {
        this.$message.error('Error al subir el archivo')
      }
    },
    computed: {
      ...mapGetters(['empresa', 'usuario'])
    }
  }
</script>

<style scoped>
  .template-container {
    padding: 40px;
    display: flex;
    justify-content: center;
    background-color: #f9f9f9;
  }

  .box-card {
    width: 100%;
    max-width: 1000px;
    padding: 30px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  .title {
    text-align: center;
    margin-bottom: 30px;
    font-size: 24px;
    font-weight: bold;
    color: #303133;
  }

  .template-section {
    display: flex;
    justify-content: space-between;
    gap: 20px;
    flex-wrap: wrap;
  }

  .subsection-card {
    display: flex;
    align-content: center;
    min-width: 300px;
    padding: 20px;
    box-shadow: none;
  }
</style>
